import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import "core-js/modules/es.array.sort.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import './currentLineHighlight.css';
import { DynamicViewOverlay } from '../../view/dynamicViewOverlay.js';
import { editorLineHighlight, editorLineHighlightBorder } from '../../../common/view/editorColorRegistry.js';
import * as arrays from '../../../../base/common/arrays.js';
import { registerThemingParticipant } from '../../../../platform/theme/common/themeService.js';
var isRenderedUsingBorder = true;
export var AbstractLineHighlightOverlay = /*#__PURE__*/function (_DynamicViewOverlay) {
  _inherits(AbstractLineHighlightOverlay, _DynamicViewOverlay);

  var _super = _createSuper(AbstractLineHighlightOverlay);

  function AbstractLineHighlightOverlay(context) {
    var _this;

    _classCallCheck(this, AbstractLineHighlightOverlay);

    _this = _super.call(this);
    _this._context = context;
    var options = _this._context.configuration.options;
    var layoutInfo = options.get(117
    /* layoutInfo */
    );
    _this._lineHeight = options.get(51
    /* lineHeight */
    );
    _this._renderLineHighlight = options.get(77
    /* renderLineHighlight */
    );
    _this._renderLineHightlightOnlyWhenFocus = options.get(78
    /* renderLineHighlightOnlyWhenFocus */
    );
    _this._contentLeft = layoutInfo.contentLeft;
    _this._contentWidth = layoutInfo.contentWidth;
    _this._selectionIsEmpty = true;
    _this._focused = false;
    _this._cursorLineNumbers = [];
    _this._selections = [];
    _this._renderData = null;

    _this._context.addEventHandler(_assertThisInitialized(_this));

    return _this;
  }

  _createClass(AbstractLineHighlightOverlay, [{
    key: "dispose",
    value: function dispose() {
      this._context.removeEventHandler(this);

      _get(_getPrototypeOf(AbstractLineHighlightOverlay.prototype), "dispose", this).call(this);
    }
  }, {
    key: "_readFromSelections",
    value: function _readFromSelections() {
      var hasChanged = false; // Only render the first selection when using border

      var renderSelections = isRenderedUsingBorder ? this._selections.slice(0, 1) : this._selections;
      var cursorsLineNumbers = renderSelections.map(function (s) {
        return s.positionLineNumber;
      });
      cursorsLineNumbers.sort(function (a, b) {
        return a - b;
      });

      if (!arrays.equals(this._cursorLineNumbers, cursorsLineNumbers)) {
        this._cursorLineNumbers = cursorsLineNumbers;
        hasChanged = true;
      }

      var selectionIsEmpty = renderSelections.every(function (s) {
        return s.isEmpty();
      });

      if (this._selectionIsEmpty !== selectionIsEmpty) {
        this._selectionIsEmpty = selectionIsEmpty;
        hasChanged = true;
      }

      return hasChanged;
    } // --- begin event handlers

  }, {
    key: "onThemeChanged",
    value: function onThemeChanged(e) {
      return this._readFromSelections();
    }
  }, {
    key: "onConfigurationChanged",
    value: function onConfigurationChanged(e) {
      var options = this._context.configuration.options;
      var layoutInfo = options.get(117
      /* layoutInfo */
      );
      this._lineHeight = options.get(51
      /* lineHeight */
      );
      this._renderLineHighlight = options.get(77
      /* renderLineHighlight */
      );
      this._renderLineHightlightOnlyWhenFocus = options.get(78
      /* renderLineHighlightOnlyWhenFocus */
      );
      this._contentLeft = layoutInfo.contentLeft;
      this._contentWidth = layoutInfo.contentWidth;
      return true;
    }
  }, {
    key: "onCursorStateChanged",
    value: function onCursorStateChanged(e) {
      this._selections = e.selections;
      return this._readFromSelections();
    }
  }, {
    key: "onFlushed",
    value: function onFlushed(e) {
      return true;
    }
  }, {
    key: "onLinesDeleted",
    value: function onLinesDeleted(e) {
      return true;
    }
  }, {
    key: "onLinesInserted",
    value: function onLinesInserted(e) {
      return true;
    }
  }, {
    key: "onScrollChanged",
    value: function onScrollChanged(e) {
      return e.scrollWidthChanged || e.scrollTopChanged;
    }
  }, {
    key: "onZonesChanged",
    value: function onZonesChanged(e) {
      return true;
    }
  }, {
    key: "onFocusChanged",
    value: function onFocusChanged(e) {
      if (!this._renderLineHightlightOnlyWhenFocus) {
        return false;
      }

      this._focused = e.isFocused;
      return true;
    } // --- end event handlers

  }, {
    key: "prepareRender",
    value: function prepareRender(ctx) {
      if (!this._shouldRenderThis()) {
        this._renderData = null;
        return;
      }

      var renderedLine = this._renderOne(ctx);

      var visibleStartLineNumber = ctx.visibleRange.startLineNumber;
      var visibleEndLineNumber = ctx.visibleRange.endLineNumber;
      var len = this._cursorLineNumbers.length;
      var index = 0;
      var renderData = [];

      for (var lineNumber = visibleStartLineNumber; lineNumber <= visibleEndLineNumber; lineNumber++) {
        var lineIndex = lineNumber - visibleStartLineNumber;

        while (index < len && this._cursorLineNumbers[index] < lineNumber) {
          index++;
        }

        if (index < len && this._cursorLineNumbers[index] === lineNumber) {
          renderData[lineIndex] = renderedLine;
        } else {
          renderData[lineIndex] = '';
        }
      }

      this._renderData = renderData;
    }
  }, {
    key: "render",
    value: function render(startLineNumber, lineNumber) {
      if (!this._renderData) {
        return '';
      }

      var lineIndex = lineNumber - startLineNumber;

      if (lineIndex >= this._renderData.length) {
        return '';
      }

      return this._renderData[lineIndex];
    }
  }]);

  return AbstractLineHighlightOverlay;
}(DynamicViewOverlay);
export var CurrentLineHighlightOverlay = /*#__PURE__*/function (_AbstractLineHighligh) {
  _inherits(CurrentLineHighlightOverlay, _AbstractLineHighligh);

  var _super2 = _createSuper(CurrentLineHighlightOverlay);

  function CurrentLineHighlightOverlay() {
    _classCallCheck(this, CurrentLineHighlightOverlay);

    return _super2.apply(this, arguments);
  }

  _createClass(CurrentLineHighlightOverlay, [{
    key: "_renderOne",
    value: function _renderOne(ctx) {
      var className = 'current-line' + (this._shouldRenderOther() ? ' current-line-both' : '');
      return "<div class=\"".concat(className, "\" style=\"width:").concat(Math.max(ctx.scrollWidth, this._contentWidth), "px; height:").concat(this._lineHeight, "px;\"></div>");
    }
  }, {
    key: "_shouldRenderThis",
    value: function _shouldRenderThis() {
      return (this._renderLineHighlight === 'line' || this._renderLineHighlight === 'all') && this._selectionIsEmpty && (!this._renderLineHightlightOnlyWhenFocus || this._focused);
    }
  }, {
    key: "_shouldRenderOther",
    value: function _shouldRenderOther() {
      return (this._renderLineHighlight === 'gutter' || this._renderLineHighlight === 'all') && (!this._renderLineHightlightOnlyWhenFocus || this._focused);
    }
  }]);

  return CurrentLineHighlightOverlay;
}(AbstractLineHighlightOverlay);
export var CurrentLineMarginHighlightOverlay = /*#__PURE__*/function (_AbstractLineHighligh2) {
  _inherits(CurrentLineMarginHighlightOverlay, _AbstractLineHighligh2);

  var _super3 = _createSuper(CurrentLineMarginHighlightOverlay);

  function CurrentLineMarginHighlightOverlay() {
    _classCallCheck(this, CurrentLineMarginHighlightOverlay);

    return _super3.apply(this, arguments);
  }

  _createClass(CurrentLineMarginHighlightOverlay, [{
    key: "_renderOne",
    value: function _renderOne(ctx) {
      var className = 'current-line current-line-margin' + (this._shouldRenderOther() ? ' current-line-margin-both' : '');
      return "<div class=\"".concat(className, "\" style=\"width:").concat(this._contentLeft, "px; height:").concat(this._lineHeight, "px;\"></div>");
    }
  }, {
    key: "_shouldRenderThis",
    value: function _shouldRenderThis() {
      return (this._renderLineHighlight === 'gutter' || this._renderLineHighlight === 'all') && (!this._renderLineHightlightOnlyWhenFocus || this._focused);
    }
  }, {
    key: "_shouldRenderOther",
    value: function _shouldRenderOther() {
      return (this._renderLineHighlight === 'line' || this._renderLineHighlight === 'all') && this._selectionIsEmpty && (!this._renderLineHightlightOnlyWhenFocus || this._focused);
    }
  }]);

  return CurrentLineMarginHighlightOverlay;
}(AbstractLineHighlightOverlay);
registerThemingParticipant(function (theme, collector) {
  isRenderedUsingBorder = false;
  var lineHighlight = theme.getColor(editorLineHighlight);

  if (lineHighlight) {
    collector.addRule(".monaco-editor .view-overlays .current-line { background-color: ".concat(lineHighlight, "; }"));
    collector.addRule(".monaco-editor .margin-view-overlays .current-line-margin { background-color: ".concat(lineHighlight, "; border: none; }"));
  }

  if (!lineHighlight || lineHighlight.isTransparent() || theme.defines(editorLineHighlightBorder)) {
    var lineHighlightBorder = theme.getColor(editorLineHighlightBorder);

    if (lineHighlightBorder) {
      isRenderedUsingBorder = true;
      collector.addRule(".monaco-editor .view-overlays .current-line { border: 2px solid ".concat(lineHighlightBorder, "; }"));
      collector.addRule(".monaco-editor .margin-view-overlays .current-line-margin { border: 2px solid ".concat(lineHighlightBorder, "; }"));

      if (theme.type === 'hc') {
        collector.addRule(".monaco-editor .view-overlays .current-line { border-width: 1px; }");
        collector.addRule(".monaco-editor .margin-view-overlays .current-line-margin { border-width: 1px; }");
      }
    }
  }
});